import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import SvgIcon from "@mui/material/SvgIcon";
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation } from 'swiper/modules';
import CarCard from "../widgets/CarCard";

import ViewInArIcon from '@mui/icons-material/ViewInAr';
import KitchenIcon from '@mui/icons-material/Kitchen';
import WaterIcon from '@mui/icons-material/Water';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import BedIcon from '@mui/icons-material/Bed';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

import Header from "./common/Header2";
import IntroDescriptionPage from "../snippets/IntroDescriptionPage";
import ContactPersons from "../widgets/ContactPersons";
import { FURNITURE } from '../helper/Icons';



const images = [
  'Slide1HeroCompare'
];


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  	children: PropTypes.node,
  	index: PropTypes.number.isRequired,
  	value: PropTypes.number.isRequired,
};

function CampingContent(props) {
	const { t, i18n } = useTranslation("",{lng: props.language});
  	let navigate = useNavigate(); 

  	const [ leftCarId, setLeftCarId] = React.useState(props.leftCar);
  	const [ rightCarId, setRightCarId] = React.useState(props.rightCar);

  	const pagination = {
    	clickable: true,
    	renderBullet: function (index, className) {
      		return '<span class="' + className + '">' + (index + 1) + '</span>';
    	},
  	};
  	
	const callModel = (url) => {
		navigate(url);
	};  	

	var models = require('../db/models.json');

  	const getCar = (which) => {
		let car;
		models.cars.forEach((value, keys) => {
			if(value.url == which)
		  		car = value;
	  })
	  return car;
  	};
  	
  	const getModel = (which) => {
		let model;
		models.models.forEach((value, keys) => {
			if(value.id == which)
		  		model = value;
	  })
	  return model;
  	};

	var leftCar = getCar(leftCarId);
	var rightCar = getCar(rightCarId);
  	
  	return (<>
			  	<Header heroImages={images} label={t("Vergleichen")} slogan={t("VergleichenSlogan")}  breadcrumb={props.props.breadcrumb} embedded={props.props.embedded}/>

				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  
							
							} }}
				>



	  				<Box  sx={{paddingTop: "0px", marginTop: "0px"}} > 

						<IntroDescriptionPage description={t("CompareDescription")}/>

						<Grid container sx={{marginTop: "50px"}}>
							<Grid item xs={12}>
								<Grid container spacing={2} >
									<Grid item xs={0} sm={1} md={1} lg={2} xl={2}>
									</Grid>
									<Grid item xs={12} sm={10} md={10} lg={8} xl={8} sx={{paddingLeft: "0px !important"}}>
												<Grid container >
													<Grid item xs={12}>
														<Grid container spacing={2} sx={{width: 'calc(100% + 32px)'}}>
															<Grid item xs={12} sx={{backgroundColor: "#fff", marginTop: "20px"}}>
																<center>
																	<h3 class="headlineCompare"><b>{t("Ausbau")}</b></h3>
																</center>
															</Grid>

															<Grid item xs={6} sx={{backgroundColor: "#fff", padding: 0, borderRight: "2px solid white"}}>
																{leftCar.label}  
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "#fff", padding: 0, borderRight: "2px solid white"}}>
																{rightCar.label}
															</Grid>

															<Grid item xs={6} sx={{backgroundColor: "#f2f2f2", borderRight: "2px solid white", marginTop: "20px"}}>
																	<Box sx={{border: "0px solid #eee", marginTop: "0px",padding: "0px", borderRadius: "0px"}}>
																		<ReactCompareSlider
																		  ref={{
																		    current: '[Circular]'
																		  }}
																		  boundsPadding={0}
																		  itemOne={<ReactCompareSliderImage alt="Image one" src={leftCar.imageDay}/>}
																		  itemTwo={<ReactCompareSliderImage alt="Image two" src={leftCar.imageNight} style={{backgroundColor: 'white', backgroundImage: '\n linear-gradient(45deg, #ccc 25%, transparent 25%),\n linear-gradient(-45deg, #ccc 25%, transparent 25%),\n linear-gradient(45deg, transparent 75%, #ccc 75%),\n linear-gradient(-45deg, transparent 75%, #ccc 75%)', backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px', backgroundSize: '20px 20px'}}/>}
																		  keyboardIncrement="5%"
																		  position={50}
									
																		  transition=".75s ease-in-out"
																		/>					        		
												        			</Box>
														<em>{t("Grundriss Tag / Nacht")}</em>
						
						
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "hsla(0,0%,94.9%,.5)", marginTop: "20px"}}>
																	<Box sx={{border: "0px solid #eee", marginTop: "0px",padding: "10px", borderRadius: "0px"}}>
																		<ReactCompareSlider
																		  ref={{
																		    current: '[Circular]'
																		  }}
																		  boundsPadding={0}
																		  itemOne={<ReactCompareSliderImage alt="Image one" src={rightCar.imageDay}/>}
																		  itemTwo={<ReactCompareSliderImage alt="Image two" src={rightCar.imageNight} style={{backgroundColor: 'white', backgroundImage: '\n linear-gradient(45deg, #ccc 25%, transparent 25%),\n linear-gradient(-45deg, #ccc 25%, transparent 25%),\n linear-gradient(45deg, transparent 75%, #ccc 75%),\n linear-gradient(-45deg, transparent 75%, #ccc 75%)', backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px', backgroundSize: '20px 20px'}}/>}
																		  keyboardIncrement="5%"
																		  position={50}
									
																		  transition=".75s ease-in-out"
																		/>					        		
												        			</Box>
														<em>{t("Grundriss Tag / Nacht")}</em>
						
															</Grid>
														</Grid>
													</Grid>
												</Grid>
									<Grid item xs={0} sm={1} md={1} lg={2} xl={2}>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						</Grid>
	



						<Grid container sx={{marginTop: "50px"}}>
							<Grid item xs={12}>
								<Grid container spacing={2} >
									<Grid item xs={0} sm={1} md={1} lg={2} xl={2}>
									</Grid>
									<Grid item xs={12} sm={10} md={10} lg={8} xl={8} sx={{paddingLeft: "0px !important"}}>

												<Grid container >
													<Grid item xs={12}>
														<Grid container spacing={2} sx={{width: 'calc(100% + 32px)'}}>
															
															<Grid item xs={12} sx={{backgroundColor: "#fff", marginTop: "20px"}}>
																<center>
																	<h3 class="headlineCompare"><b>{t("Ausstattung")}</b></h3>
																</center>
															</Grid>
															<Grid item xs={12} sx={{backgroundColor: "#fff", marginTop: "20px"}}>
																<center>
																	<h3 class="headlineCompare">{t("Schlafen")}</h3>
																</center>
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "#f2f2f2", padding: 0, borderRight: "2px solid white"}}>
																<center>
																	<ul class="empty2" >
																		<li><BedIcon sx={{fontSize: "1.5em"}}/>{leftCar.equipment.sleeping}</li>
																	</ul>
																</center>											        			
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "hsla(0,0%,94.9%,.5)", padding: 0}}>
																<center>
																	<ul class="empty2" >
																		<li><BedIcon sx={{fontSize: "1.5em"}}/>{rightCar.equipment.sleeping}</li>
																	</ul>											        																		
																</center>
															</Grid>
															<Grid item xs={12} sx={{backgroundColor: "#fff", marginTop: "20px"}}>
																<center>
																	<h3 class="headlineCompare">{t("Möbel")}</h3>
																</center>
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "#f2f2f2", padding: 0, borderRight: "2px solid white"}}>
																<center>
																	<ul class="empty2" >
																		<li><KitchenIcon sx={{fontSize: "1.5em"}}/>{leftCar.equipment.furniture}</li>
																	</ul>
																</center>											        			
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "hsla(0,0%,94.9%,.5)", padding: 0}}>
																<center>
																	<ul class="empty2" >
																		<li><KitchenIcon sx={{fontSize: "1.5em"}}/>{rightCar.equipment.furniture}</li>
																	</ul>											        																		
																</center>
															</Grid>
															<Grid item xs={12} sx={{backgroundColor: "#fff", marginTop: "20px"}}>
																<center>
																	<h3 class="headlineCompare">{t("Wasseranlage")}</h3>
																</center>
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "#f2f2f2", padding: 0, borderRight: "2px solid white"}}>
																<center>
																	<ul class="empty2" >
																		<li><WaterIcon sx={{fontSize: "1.5em"}}/>{leftCar.equipment.waterFacility}</li>
																	</ul>
																</center>											        			
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "hsla(0,0%,94.9%,.5)", padding: 0}}>
																<center>
																	<ul class="empty2" >
																		<li><WaterIcon sx={{fontSize: "1.5em"}}/>{rightCar.equipment.waterFacility}</li>
																	</ul>											        																		
																</center>
															</Grid>
															<Grid item xs={12} sx={{backgroundColor: "#fff", marginTop: "20px"}}>
																<center>
																	<h3 class="headlineCompare">{t("Gas")}</h3>
																</center>
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "#f2f2f2", padding: 0, borderRight: "2px solid white"}}>
																<center>
																	<ul class="empty2" >
																		<li><PropaneTankIcon sx={{fontSize: "1.5em"}}/>{leftCar.equipment.gas}</li>
																	</ul>
																</center>											        			
															</Grid>
															<Grid item xs={6} sx={{backgroundColor: "hsla(0,0%,94.9%,.5)", padding: 0}}>
																<center>
																	<ul class="empty2" >
																		<li><PropaneTankIcon sx={{fontSize: "1.5em"}}/>{rightCar.equipment.gas}</li>
																	</ul>											        																		
																</center>
															</Grid>


													</Grid>
												</Grid>
											</Grid>
									</Grid>
									<Grid item xs={0} sm={1} md={1} lg={2} xl={2}>
									</Grid>
								</Grid>
							</Grid>
						</Grid>


<Grid container sx={{marginTop: "50px"}}>
							<Grid item xs={12}>
								<Grid container spacing={2} >
									<Grid item xs={0} sm={1} md={1} lg={2} xl={2}>
									</Grid>
									<Grid item xs={12} sm={10} md={10} lg={8} xl={8} sx={{paddingLeft: "0px !important"}}>
										<Grid container >
											<Grid item xs={12}>
												<Grid container spacing={2} sx={{width: 'calc(100% + 32px)'}}>
													<Grid item xs={12} sx={{backgroundColor: "#fff", marginTop: "20px", marginBottom: "20px"}}>
														<center>
															<h3 class="headlineCompare"><b>{t("Fahrzeuge")}</b></h3>
Folgende Fahrzeuge nutzen entsprechende Ausbauten.
														</center>
													</Grid>
													<Grid item xs={6} sx={{backgroundColor: "#f2f2f2", borderRight: "2px solid white"}}>
														<center>
															<b>{leftCar.label}</b>
														</center>
							     	   					<Swiper
														        slidesPerView={1}
														        spaceBetween={30}
														        navigation={true}
														        freeMode={true}
														        pagination={{
														          clickable: true,
														        }}
														        modules={[FreeMode, Pagination, Navigation]}
																className="myNews"
														        style={{minHeight: "680px", paddingTop: "40px", backgroundColor: "hsla(0,0%,94.9%,.5)"}}
														      >
																{models.cars.map((model) => (
																	<>
																		{model.onlinestatus == "online" && model.label == leftCar.label ? (
																        	<SwiperSlide>
																				<CarCard model={model}/>																						
																        	</SwiperSlide>
																			):(<></>)
																		}
														        	</>
														        ))}
														</Swiper>

													</Grid>
													<Grid item xs={6} sx={{backgroundColor: "hsla(0,0%,94.9%,.5)"}}>
														<center>
															<b>{rightCar.label}</b>
														</center>
							     	   					<Swiper
														        slidesPerView={1}
														        spaceBetween={30}
														        navigation={true}
														        freeMode={true}
														        pagination={{
														          clickable: true,
														        }}
														        modules={[FreeMode, Pagination, Navigation]}
																className="myNews"
														        style={{minHeight: "680px", paddingTop: "40px", backgroundColor: "hsla(0,0%,94.9%,.5)"}}
														      >
																{models.cars.map((model) => (
																	<>
																		{model.onlinestatus == "online" && model.label == rightCar.label ? (
																        	<SwiperSlide>
																				<CarCard model={model}/>																						
																        	</SwiperSlide>
																			):(<></>)
																		}
														        	</>
														        ))}
														</Swiper>
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									<Grid item xs={0} sm={1} md={1} lg={2} xl={2}>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						</Grid>


			      																		
					</Box>

	  				<Box sx={{paddingTop: "40px"}}> 
						<ContactPersons/>
					</Box>
   			</Box>
   		</>
   	)
}

export default function Compare(props) {
	
  const postData = useLocation();
  console.log("POST DATA:", postData.state);	
	
  return <CampingContent props={props} leftCar={postData.state.leftCar} rightCar={postData.state.rightCar}/>;
}